import { z } from "zod";
import { Id, NonEmpty } from "./base";
// todo check if ID is really optional
export const CreateRecordSchema = z.object({
    collection: NonEmpty,
    documentId: Id.optional(),
    payload: z.record(z.string(), z.unknown()).describe("payload is required"),
});
export const GetRecordParamsSchema = z.object({
    collection: NonEmpty,
    documentId: Id,
});
